import XLSXUploader from "@/components/XLSXUploader"
import { ProcessStatus } from "@/components/ProcessStatusView"
import TriggerView from "./components/Trigger.vue"
import triggerDataParserFactory from "./services/trigger-data-parser"
import triggerCreatorFactory, { TriggerCreator } from "./services/trigger-creator"
import triggerTesterFactory, { TriggerTester } from "./services/trigger-tester"



export default {
    name: 'TriggerCreatorView',
    components: {
        XLSXUploader,
        TriggerView
    },
    data: function() {
        console.log(process.env.BASE_URL);
        return {
            form: {
                testEmailAddress: "",
                testSubscriberKey: "",
                useAccessToken: "false"
            },
            triggers: [],
            triggersSequence: 1,
            files: [],
            publicPath: process.env.BASE_URL,
            apiResponse: null
        };
    },
    created: function () {
        this.$triggerDataParser = triggerDataParserFactory(this);
    },
    computed: {
    },
    methods:  {
        xlsxUpload: function(files) {
            var file = files[0];
            this.triggers.push({
                id: this.triggersSequence++,
                file: file.file,
                data: this.$triggerDataParser.parse(file.xlsx),
                processStatus: {
                    create: new ProcessStatus(TriggerCreator.PROCESS_STATES.IDLE),
                    test: new ProcessStatus(TriggerTester.PROCESS_STATES.IDLE)
                }
            });
        },
        triggerDelete: function(id) {
            var trigger = this.triggers.find((element) => {
                return element.id == id;
            });
            if (trigger) {
                this.triggers.splice(this.triggers.indexOf(trigger), 1);
            }
        },
        submit: function() {
            this.$triggerCreator = triggerCreatorFactory(this);
            return this.createTriggers(
                this.triggers.slice(0)
            );
        },
        createTriggers: function(triggers) {
            var trigger;
            if (triggers.length) {
                trigger = triggers.shift();
                trigger.processStatus.create.reset()
                return this.$triggerCreator.create(
                    trigger.data,
                    trigger.processStatus.create
                ).then(
                    () => this.createTriggers(triggers),
                    (error) => {
                        trigger.processStatus.create.state = TriggerCreator.PROCESS_STATES.ERROR;
                        trigger.processStatus.create.error(
                            error.apiResponseMessage,
                            error.apiResponseRaw
                        )
                    }
                );
            } else {
                return Promise.resolve();
            }
        },

        test: function() {
            this.$triggerTester = triggerTesterFactory(this);
            this.triggers.forEach((trigger) => {
                trigger.processStatus.test.state = TriggerTester.PROCESS_STATES.QUEUED;
            });
            return this.testTriggers(
                this.triggers.slice(0)
            ).catch(
                (error) => {
                    if (error.response && error.response.data) {
                        this.apiResponse = error.response.data;
                    } else {
                        this.apiResponse = error;
                    }
                }
            );
        },
        testTriggers: function(triggers) {
            var trigger;
            if (triggers.length) {
                trigger = triggers.shift();
                trigger.processStatus.test.reset();
                trigger.processStatus.test.state = TriggerTester.PROCESS_STATES.TESTING;
                return this.$triggerTester.test(
                    trigger.data,
                    trigger.processStatus.test,
                    this.form
                ).then(
                    () => {
                        trigger.processStatus.test.state = TriggerTester.PROCESS_STATES.DONE;
                        return this.testTriggers(triggers)
                    },
                    (error) => {
                        trigger.processStatus.test.state = TriggerTester.PROCESS_STATES.ERROR;
                        trigger.processStatus.test.error(
                            error.apiResponseMessage,
                            error.apiResponseRaw
                        )
                    }
                )
            } else {
                return Promise.resolve();
            }
        },

        makeSoapEnvelopes: function() {
            import(
                "./services/trigger-make-soap-envelope"
            ).then(
                (module) => {
                    module.default(this.triggers, this.form, this);
                }
            );
        },

        makeRestCalls: function() {
            import(
                "./services/trigger-make-rest-call"
            ).then(
                (module) => {
                    module.default(this.triggers, this.form, this);
                }
            );
        },

        makeAmpScriptInvocation: function() {
            import(
                "./services/trigger-make-ampscript-invocation"
            ).then(
                (module) => {
                    module.default(this.triggers, this.form, this);
                }
            );
        }
    }
}
